// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3_RMn","title":"BackImages_title__3Jqdz","images":"BackImages_images__1mO18"};